import Link from 'next/link';
import { useRouter } from 'next/router';
import { Transition } from '@headlessui/react';
import { ArrowRightIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { Routes } from '../../util/routes';


export type CommunityItem = {
  href: string;
  label: string;
};

type Props = {
  isOpen: boolean;
};

type CommunityListProps = {
  isMobile?: boolean;
};

function CommunityList({ isMobile }: CommunityListProps) {
  const router = useRouter();

  const communityItems: CommunityItem[] = [
    {
      label: 'Blog',
      href: Routes.blog(router.query['company-slug'] as string),
    },
    {
      label: 'Guides',
      href: Routes.guides(router.query['company-slug'] as string),
    },
    // JOV-5434: jobs-api decommissioned, hide Jobs nav link
    // {
    //   label: 'Jobs',
    //   href: Routes.jobs(router.query['company-slug'] as string),
    // },
    {
      label: 'IR35',
      href: Routes.ir35(router.query['company-slug'] as string),
    },
  ];

  const activeItemClassName = clsx('block px-4 py-2 capitalize', {
    'text-gray-dark hover:text-brand-primary transition-colors duration-75':
      !isMobile,
    'text-base font-semibold text-white': isMobile,
  });

  return (
    <>
      {communityItems.map((item) => (
        <li key={item.label}>
          <Link href={item.href} className={activeItemClassName}>
            {item.label}
            <ArrowRightIcon className="ml-2 inline-block h-4" />
          </Link>
        </li>
      ))}
    </>
  );
}

export default function JoveCommunityBar({ isOpen }: Props) {
  return (
    <div className="relative hidden w-full items-center justify-center md:block">
      <Transition
        show={isOpen}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100 border-t"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="absolute left-0 top-0 w-full bg-white shadow-md"
      >
        <ul className="container  flex list-none items-center justify-evenly py-2 text-sm font-semibold">
          <li className="mx-6 h-4"></li>
          <CommunityList />
        </ul>
      </Transition>
    </div>
  );
}